const Title = ({title}) => <h1>{title}</h1>

export default Title;
